import * as React from 'react'

import classNames from 'classnames/bind'

import PanesPad from 'modules/core/components/PanesPad'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  direction: 'vertical' | 'horizontal'
  boxed?: boolean
  compact?: boolean
  multiple?: boolean
}

const PanesPadForm = ({
  compact,
  direction,
  boxed,
  multiple,
  children: rawChildren,
}: React.PropsWithChildren<Props>) => {
  const className = cx('padForm', direction)
  const children = React.Children.toArray(rawChildren)

  if (!multiple && children.length !== 2) {
    throw new Error('Non-multiple PadForm expects two children elements')
  }

  const content = (
    <div className={className}>
      {!multiple && (
        <>
          <Left>{children[0]}</Left>
          <Right>
            <Form boxed={boxed}>{children[1]}</Form>
          </Right>
        </>
      )}
      {multiple && children}
    </div>
  )

  if (compact) return content

  return <PanesPad>{content}</PanesPad>
}

const Left = ({ children }: React.PropsWithChildren) => {
  return <div className={styles.left}>{children}</div>
}

const Right = ({ children }: React.PropsWithChildren) => {
  return <div className={styles.right}>{children}</div>
}

interface FormProps {
  boxed?: boolean
}

const Form = ({ boxed, children }: React.PropsWithChildren<FormProps>) => {
  const className = cx({ boxed })

  return <div className={className}>{children}</div>
}

PanesPadForm.Left = Left
PanesPadForm.Form = Form
PanesPadForm.Right = Right

export default PanesPadForm
